import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21.5 20.5h-20l10-18 10 18zm-10-4.5v2m0-10v6" stroke="currentColor" fill="none" /></svg>;